import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const verifyEmail = async (input) => {
  try {
    const { data } = await http_payroll.post(Api_EndPoints.VerifyEmail, input);
    if (!data) {
      throw new Error("No data returned from API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

export const useVerifyEmailMutation = () => {
  return useMutation({
    mutationFn: verifyEmail,
  });
};

const verifyOTP = async (input) => {
  try {
    const { data } = await http_payroll.post(Api_EndPoints.VerifyOTP, input);
    if (!data) {
      throw new Error("No data returned from API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

export const useVerifyOTPMutation = () => {
  return useMutation({
    mutationFn: verifyOTP,
  });
};

const resetUserPassword = async (input) => {
  try {
    const { data } = await http_payroll.post(
      Api_EndPoints.ResetPassword,
      input
    );
    if (!data) {
      throw new Error("No data returned from API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: resetUserPassword,
  });
};
